import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core'
import { AttachmentUploadedType } from '../../../../api/backend'
import { Store } from '@ngrx/store'
import { Observable, Subscription } from 'rxjs'
import { CommonDomainComponentsActions } from '../../../../domain/attachment/components/attachment-type-scan-data/state/action-types'
import { selectAttachmentTypeScanState } from '../../../../domain/attachment/components/attachment-type-scan-data/state/common-domain-components.selectors'
import { ContractTypeEnum } from '../../../../shared/enums/contract-type.enum'
import { ComponentModeEnum } from '../../../../shared/enums/component-mode.enum'
import {
    selectContractShowContractOwners,
} from '../../../../features/contracts/contract/show/state/show.selectors'
import { selectContractEditOwners } from '../../../../features/contracts/contract/edit/state/edit.selectors'
import {
    selectSubcontractShowContractOwners,
} from '../../../../features/contracts/subcontract/show/state/subcontract-show.selectors'
import { selectSubcontractEditOwners } from '../../../../features/contracts/subcontract/edit/state/subcontract-edit.selectors'
import { selectNonCadastralContractCreateOwners } from '../../../../features/non-cadastral/non-cadastral-contract/create/state/non-cadastral-contract-create.selectors'
import cloneDeep from 'lodash/cloneDeep'

@Component({
    selector: 'ca-attachment-type-scan-data',
    templateUrl: './attachment-type-scan-data.html'
})
export class AttachmentTypeScanDataComponent implements OnInit, OnDestroy {

    @Input() task: string
    @Input() mode: string

    attachmentTypesScan = [{id: AttachmentUploadedType.CONTRACT, name: 'smlouva'},
        {id: AttachmentUploadedType.NOTICE, name: 'výpověď'},
        {id: AttachmentUploadedType.OTHERS, name: 'ostatní'}]
    checkedAll = false
    checkedIds = []
    owners: any[]
    uploadedType: AttachmentUploadedType

    owners$: Observable<any>
    #selectAttachmentTypeScanState: Subscription
    #owners: Subscription

    constructor(@Inject(Store) private store: Store,
                ) {
        this.#selectAttachmentTypeScanState = this.store.select(selectAttachmentTypeScanState).subscribe(data => {
            this.uploadedType = data.uploadedType
            this.checkedAll = data.checkedAll
            this.checkedIds = data.checkedIds
        })
    }

    ngOnInit() {
        switch (this.task) {
            case ContractTypeEnum.CONTRACT:
                this.owners$ = this.mode === ComponentModeEnum.SHOW ? this.store.select(selectContractShowContractOwners) : this.store.select(selectContractEditOwners)
                break
            case ContractTypeEnum.SUBCONTRACT:
                this.owners$ = this.mode === ComponentModeEnum.SHOW ? this.store.select(selectSubcontractShowContractOwners) : this.store.select(selectSubcontractEditOwners)
                break
            case ContractTypeEnum.NONCADASTRALCONTRACT:
                this.owners$ = this.store.select(selectNonCadastralContractCreateOwners)
                break
        }
        this.#owners = this.owners$.subscribe(owners => {
            this.owners = cloneDeep(owners) // Clone in to orderBy pipe can modify the array

            if (this.owners?.length === 1) {
                this.store.dispatch(CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
                    property: 'checkedIds',
                    value: [this.owners[0].id]
                }))
            }
        })
    }

    ngOnDestroy() {
        this.#selectAttachmentTypeScanState?.unsubscribe()
        this.#owners?.unsubscribe()
        this.store.dispatch(CommonDomainComponentsActions.resetAttachmentTypeScanData())
    }

    isSubjectChecked(id): boolean {
        return (this.checkedAll === false && this.checkedIds.indexOf(id) > -1)
            || this.checkedAll
    }

    onChangeAttachmentType(): void {
        this.store.dispatch(CommonDomainComponentsActions.setAttachmentTypeScanDataProperty({
            property: 'uploadedType',
            value: this.uploadedType
        }))
    }

    toggleCheckAll(): void {
        this.store.dispatch(CommonDomainComponentsActions.setAttachmentTypeScanDataToggleCheckAll({
            ownerIds: this.owners ? this.owners.map(o => o.id) : []
        }))
    }

    toggleCheckSubject(id): void {
        this.store.dispatch(CommonDomainComponentsActions.setAttachmentTypeScanDataToggleCheckSubject({
            id: id,
            ownersLength: this.owners ? this.owners.length : 0
        }))
    }

}
